import { Pipe, PipeTransform, inject } from '@angular/core';
import { AdminDictionaryProductAttributeSelectItemsProviderService } from '../providers/admin-dictionary-product-attribute-label-provider.service';
import { Guid, isNil, Nillable } from '@web/utils';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'adminDictionaryProductAttributeLabel',
})
export class AdminDictionaryProductAttributeLabelPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly provider = inject(AdminDictionaryProductAttributeSelectItemsProviderService);

  public transform(id: Nillable<Guid>): Observable<Nillable<string>> {
    if (isNil(id)) {
      return of(null);
    }

    return this.provider.fetchLabelFor(id, true);
  }
}
